var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesHorizontalShortBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1968",
    fill: "none",
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 69",
    d: "M48.5 24V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 70",
    d: "M36.5 24V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 71",
    d: "M24.5 24V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 66",
    d: "M12.5 24V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 60",
    d: "M.5 24V0"
  }))));
}
export default "/_next/static/assets/public/graphics/clearing/f2125f00f6d5378ea3572b61d65480a5.svg";
export { SvgLinesHorizontalShortBlack as ReactComponent };